export default __webpack_public_path__ + "static/media/offer7.06b072ce.png";